import { BrowserRouter as Router, Route, Switch, Link} from "react-router-dom";
import Services from './components/Servises'
import Blog from './components/Blog'
import Contacts from './components/Contacts'
import NotFound from './components/NotFound'
import Card1 from "./Cards/Card1";
import Footer from "./parts/Footer";
import NavMenu from "./parts/NavMenu"


export default function App() {

  return <>
    <Router>
      <div>
       
        <NavMenu />
        <Switch>
        <Route exact path="/" component={Services} />
        <Route path="/blog" component={Blog} />
        <Route path="/contacts" component={Contacts} />
        <Route path="/card1" component={Card1} /> 
        <Route component={NotFound} />
        </Switch>
        </div>
    </Router>
        <Footer/>
    </>
}